// import adapter from 'webrtc-adapter';
// console.error("webrtc-adapter load");

var adapter = emedia.singleWebrtcAdapter;

function warn() {
    emedia.util.logger.warn("webrtc-adapter must load once. if more, safari may initC sdp error(too many audio video, easemob server dont work)");
}

function requireWebrtcAdapter() {
    if (!!document.documentMode) { // Detect IE (6-11)
        var hasMatch = /\brv[ :]+(\d+)/g.exec(navigator.userAgent) || [];

        var webrtcDetectedBrowser   = 'IE';
        var webrtcDetectedVersion   = parseInt(hasMatch[1], 10);
        var webrtcMinimumVersion    = 9;
        var webrtcDetectedType      = 'plugin';
        var webrtcDetectedDCSupport = 'SCTP';

        if (!webrtcDetectedVersion) {
            hasMatch = /\bMSIE[ :]+(\d+)/g.exec(navigator.userAgent) || [];

            webrtcDetectedVersion = parseInt(hasMatch[1] || '0', 10);
        }

        //adapter = require('./adapter.ie');
        emedia.util.logger.error("adapter.ie not required");

        adapter.__browser = webrtcDetectedBrowser;
        adapter.__browserVersion = webrtcDetectedVersion;

        //adapter = require('./Temasys.wrapper'); //6.0.3
    }else{
        //adapter = require('./adapter-6.2.0'); //6.2.0
        //adapter = require('webrtc-adapter').default; //webim demo minify 时 util报错
        adapter = require('./adapter-7.6.1');
        emedia.util.logger.info("webrtc-adapter load first");

        wrapAttachMediaStream();
    }

    emedia.singleWebrtcAdapter = adapter;
}

warn();
if(!adapter){
    requireWebrtcAdapter();
}else{
    emedia.util.logger.error("webrtc-adapter repeated load, safari may dont work");
}

adapter.__browser = adapter.__browser || adapter.browserDetails.browser; // firefox chrome safari
adapter.__browserVersion = adapter.__browserVersion || adapter.browserDetails.version;

emedia.util.logger.info("Current browser", adapter.__browser, adapter.__browserVersion);

if("Not a supported browser." === adapter.__browser){
    emedia.util.logger.error("Not a supported browser");
}

//module.exports = adapter;
export default adapter;

function wrapAttachMediaStream() {
    function _attachMediaStream(element, stream) {
        element.srcObject = stream;

        if(emedia.isSafari){
            // var hasActivedTrack = false;
            // stream.getVideoTracks().forEach((track)=>{
            //     if(!hasActivedTrack){
            //         hasActivedTrack = track.enabled;
            //     }
            // });
            //
            // if(!hasActivedTrack){
            //     element.pause();
            //     element.play();
            // }

            element.pause();
            element.play();
        }

        var logger = emedia.util.logger || window.console || console;

        if(logger){
            stream && logger.info("stream attach videoTag.", stream.id, stream._located, ">>",
                element.id, element.muted, element.volume, element);
            stream || logger.info("stream(null) attach videoTag.", element.id, element.muted, element.volume, element);

            if(!element.hxSetOnvolumechange){
                var preonvolumechange = element.onvolumechange;
                element.onvolumechange = function(){
                    logger.debug("stream attach detail: video tag volume chanage", element.volume, stream ? stream.id : stream);
                    preonvolumechange && preonvolumechange.apply(element, arguments);
                };
                element.hxSetOnvolumechange = true;
            }

            if(!element.hxSetOnstalled){
                var preonstalled = element.onstalled;
                element.onstalled = function () {
                    logger.debug("stream attach detail: video tag onstalled", stream ? stream.id : stream);
                    preonstalled && preonstalled.apply(element, arguments);
                };
                element.hxSetOnstalled = true;
            }

            if(!element.hxSetOnabort){
                var preonabort = element.onabort;
                element.onabort = function () {
                    logger.debug("stream attach detail: video tag onabort", stream ? stream.id : stream);
                    preonabort && preonabort.apply(element, arguments);
                };
                element.hxSetOnabort = true;
            }

            if(!element.hxSetOncanplay){
                var preOncanplay = element.oncanplay;
                element.oncanplay = function(){
                    stream && stream.getTracks().forEach(function(track) {
                        if(typeof track.getSettings === 'function'){
                            logger.debug('stream attach detail', stream.id,
                                " track setting =", track.enabled, track.id, track.kind, track.label, track.getSettings());
                        }
                    });

                    logger.debug("stream attach detail: video tag", element.videoWidth, "x", element.videoHeight, stream ? stream.id : stream);

                    preOncanplay && preOncanplay.apply(element, arguments);
                };
                element.hxSetOncanplay = true;
            }
        }
    }

    /**
     * muted undefined, stream _located true 时muted
     *
     * @param element
     * @param stream
     * @param muted
     * @returns {*}
     */
    function hxbAttachMediaStream(element, stream, muted, _fun) {
        function mute() {
            muted = !!(muted === undefined ? stream._located : muted);

            //为了解决某些手机mute造成本地图像卡的问题
            element.muted = false;
            if(muted !== element.muted){
                element.muted = true;
            }
        }

        _fun || (_fun = window.__attachMediaStream) || (_fun = _attachMediaStream.bind(this));

        if(!element){
            return;
        }

        if(!stream){
            _fun(element, stream);
            return;
        }

        if(!element.srcObject){
            mute();
            _fun(element, stream);
            return element;
        }

        if(element.srcObject._located //old stream 也是 _located
            && stream._located
            && element.srcObject.id === stream.id){
            return element.srcObject;
        }

        mute();
        _fun(element, stream);

        return element;
    }

    if(window.attachMediaStream && window.attachMediaStream._wrapped !== true){
        window.__attachMediaStream = window.attachMediaStream;
    }

    window.attachMediaStream = hxbAttachMediaStream;
    window.attachMediaStream._wrapped = true;
    console && typeof console.info === "function" && console.info("Wrap the attachMediaStream ", adapter.__browser, adapter.__browserVersion);
}


